import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SPACING_TOKENS } from '../../../design-system/tokens/spacing';

/**
 * Foundations › Spacing — documentación de los tokens de espaciado.
 *
 * La tabla se genera desde la fuente de verdad `SPACING_TOKENS`
 * (`src/design-system/tokens/spacing.ts`), los mismos valores que quedan
 * disponibles en toda la app como utilidades de Tailwind (`p-space200`, etc.).
 *
 * Estilo de tabla inspirado en Atlassian Design (filas con divider, token como
 * chip monospace, barra violeta como representación visual). Columnas y valores
 * son los del style guide de Atlas: Name · Pixels · Spacing.
 *
 * El ancho de cada barra se deriva del valor en px del token; los valores grandes
 * (`space9999`/1000px) quedan clampeados al ancho de la celda.
 */
export const DSSpacingPage: React.FC = () => (
  <div className="px-10 py-12">
    <div className="mx-auto flex w-full max-w-[800px] flex-col gap-10">
      <PageHeader
        title="Spacing"
        description="Sistema de espaciado predefinido y limitado para diseñar con mayor rapidez y consistencia. Se usan en márgenes, paddings y gaps para mantener el orden en todos los componentes del diseño."
      />

      {/* `table-fixed` + anchos de columna: así la columna Spacing tiene ancho
          definido y el bar (maxWidth 100%) se clampea a ella; sin esto, un bar
          grande (space9999/1000px) estiraría la celda y rompería el layout. */}
      <table className="w-full table-fixed border-collapse text-left">
        <colgroup>
          <col className="w-[220px]" />
          <col className="w-[120px]" />
          <col />
        </colgroup>
        <thead>
          <tr className="border-b border-neutral-300">
            <th className="py-3 pr-8 text-[14px] font-semibold text-neutral-900">Name</th>
            <th className="py-3 pr-8 text-[14px] font-semibold text-neutral-900">Pixels</th>
            <th className="py-3 text-[14px] font-semibold text-neutral-900">Spacing</th>
          </tr>
        </thead>
        <tbody>
          {SPACING_TOKENS.map((token, i) => (
            <tr key={`${token.name}-${i}`} className="border-b border-neutral-200">
              <td className="whitespace-nowrap py-4 pr-8 align-middle">
                <code className="rounded bg-neutral-100 px-1.5 py-0.5 font-mono text-[13px] text-neutral-700">
                  {token.name}
                </code>
              </td>
              <td className="whitespace-nowrap py-4 pr-8 align-middle text-[15px] text-neutral-600">
                {token.px}px
              </td>
              <td className="w-full py-4 align-middle">
                <div
                  className="h-5 rounded-[3px] bg-[#8B5CF6]"
                  style={{ width: `${token.px}px`, maxWidth: '100%' }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
